/**
 * Woodie Pivot Points
 *
 * Pivot point system placing more weight on the closing price.
 * PP = (H + L + 2×C) / 4
 *
 * Category: Support/Resistance | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const woodiePivotIndicator: IndicatorDefinition = {
  id: "woodie_pivot",
  name: "Woodie Pivot Points",
  shortName: "W-PVT",
  category: "support_resistance",
  pane: "overlay",
  params: [],
  plots: [
    { key: "pp", label: "PP", color: "#FF9800", style: "line", lineWidth: 2 },
    { key: "r1", label: "R1", color: "#F44336", style: "line", lineWidth: 1 },
    { key: "r2", label: "R2", color: "#D32F2F", style: "line", lineWidth: 1 },
    { key: "s1", label: "S1", color: "#4CAF50", style: "line", lineWidth: 1 },
    { key: "s2", label: "S2", color: "#388E3C", style: "line", lineWidth: 1 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    if (candles.length < 2) {
      return ["pp","r1","r2","s1","s2"].map(k => ({ key: k, data: [] }));
    }
    const prev = candles[candles.length - 2];
    const pp = (prev.high + prev.low + 2 * prev.close) / 4;
    const r1 = 2 * pp - prev.low;
    const r2 = pp + (prev.high - prev.low);
    const s1 = 2 * pp - prev.high;
    const s2 = pp - (prev.high - prev.low);

    const makeLine = (val: number) => candles.map(c => ({ time: c.time, value: val }));
    return [
      { key: "pp", data: makeLine(pp) },
      { key: "r1", data: makeLine(r1) },
      { key: "r2", data: makeLine(r2) },
      { key: "s1", data: makeLine(s1) },
      { key: "s2", data: makeLine(s2) },
    ];
  },
};
